import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { imageService } from '@bedrock/fido-sdk';
import { IMAGE_FIT_SCALE_CROP, IMAGE_QUALITY, TRANSPARENT_IMAGE_FORMAT } from '@bedrock-rdk/constants';
import Icon from '../../../../tornado/icon/icon.component';
import { getIconViewBox, getInitialStyle, defaultContext, getImageSize } from './sidenavIcon.style';

export default class SidenavIcon extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Icon: {
          type: Icon,
        },
        Image: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
      },
      getInitialStyle(),
    );
  }

  _detach() {
    this.tag('Image').removeAllListeners('txLoaded');
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  _construct() {
    this._style = defaultContext;
  }

  set content(value) {
    const { picto, image } = value || {};
    const { w, h } = getImageSize(this._style.screenSize);
    const src =
      image && image.id
        ? imageService.getUrl(image.id, w, h, {
            fit: IMAGE_FIT_SCALE_CROP,
            quality: IMAGE_QUALITY,
            format: TRANSPARENT_IMAGE_FORMAT,
          })
        : '';

    const view = this.tag(src ? 'Image' : 'Icon');

    view.on('txLoaded', () => {
      view.setSmooth('alpha', 1);
    });

    this.patch({
      Icon: {
        alpha: 0.0001,
        visible: !src,
        iconData: {
          picto,
          viewBox: getIconViewBox(this._style.screenSize),
        },
      },
      Image: {
        alpha: 0.0001,
        w,
        h,
        visible: Boolean(src),
        src,
      },
    });
  }
}
